import { render, staticRenderFns } from "./invoiceAdd.vue?vue&type=template&id=4f3665f0&scoped=true&"
import script from "./invoiceAdd.vue?vue&type=script&lang=js&"
export * from "./invoiceAdd.vue?vue&type=script&lang=js&"
import style0 from "./invoiceAdd.vue?vue&type=style&index=0&id=4f3665f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3665f0",
  null
  
)

export default component.exports